'use client';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { ErrorMessageBannerProps } from './types';
import { CatIconWarningCircle } from 'blocks-nextjs/blocks-react/components/Icons/WarningCircle';

const ErrorMessageBanner: ErrorMessageBannerProps = ({
  children,
  heading = '',
  ...rest
}) => {
  return (
    <CatInlineNotification heading={heading} variant={'error'} {...rest}>
      <CatIconWarningCircle slot="before" data-testid="error-icon" />
      {children}
    </CatInlineNotification>
  );
};

export default ErrorMessageBanner;
